

import React, { memo } from 'react';
import cx from 'classnames';
import Indicator from './Indicator';
import { COMMENT_VISIBILITY_STYLES } from '../../../../../constants/commentVisibilityStyles';

import '../styles/_indicators.scss';

function calculateLeftPercent(timestamp, totalDuration) {
  if (Number.isNaN(Number(timestamp))) {return null;}

  return timestamp / totalDuration * 100;
}










function Indicators({
  onClickIndicator,
  userAssignedColors,
  comments,
  totalDuration,
  className,
  isV2Design
}) {
  return (
    <div className={cx('comment-indicators', className)}>
      {comments.map((comment) => {
        const { commentId, createdByUser, timestamp, metadata } = comment;
        const { visibility, isRejected } = JSON.parse(metadata || '{}');

        if (!commentId || !createdByUser || isRejected) {return null;}

        const assignedColors = {
          ...userAssignedColors[createdByUser.userId],
          ...(
          isV2Design && visibility &&
          { color: COMMENT_VISIBILITY_STYLES[visibility].bgColor })

        };

        const leftPercent = calculateLeftPercent(timestamp, totalDuration);

        if (leftPercent === null) {return null;}

        return (
          <Indicator
            key={commentId}
            commentId={commentId}
            onClick={onClickIndicator(comment)}
            colour={assignedColors}
            leftPercent={leftPercent} />);


      })}
    </div>);

}

export default memo(Indicators);